import React from 'react';
import { DRNInputField } from '@traveloka/district-ui';
import format from 'date-fns/format';
import PropTypes from 'prop-types';

import Modal from '../Modal/Modal';
import Calendar from '../Calendar/Calendar';
import TimePicker from '../TimePicker/TimePicker';
import getDateFNSLocale from 'common/utils/date/getDateFNSLocale';
import TouchableInputFieldWrapper from 'common/components/TouchableInputFieldWrapper/TouchableInputFieldWrapper';

export const DATE_PICKER = 'date';
export const TIME_PICKER = 'time';
export const DATETIME_PICKER = 'datetime';

class InputDateField extends React.Component {
  static propTypes = {
    value: PropTypes.object,
    defaultValue: PropTypes.object,
    onDateChange: PropTypes.func,
    maximumDate: PropTypes.object,
    minimumDate: PropTypes.object,
    mode: PropTypes.oneOf([DATE_PICKER, TIME_PICKER, DATETIME_PICKER]),
    format: PropTypes.string,
    locale: PropTypes.string,
    minuteInterval: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 10, 12, 15, 20, 30]),
    hideDefaultValue: PropTypes.bool,
    // TODO (yusei)
    timeZoneOffsetInMinutes: PropTypes.number,
  };

  static defaultProps = {
    mode: DATE_PICKER,
    locale: 'id',
  };

  state = {
    date: this.props.defaultValue || new Date(),
    currentMode:
      this.props.mode === DATETIME_PICKER ? DATE_PICKER : this.props.mode,
    modalOpen: false,
  };

  getDate = () => this.props.value || this.state.date;

  handleOpenDatePicker = () => {
    const { mode } = this.props;

    this.setState({
      modalOpen: true,
      currentMode: mode === DATETIME_PICKER ? DATE_PICKER : mode,
    });
  };

  handleCloseDatePickerModal = () => {
    this.setState(
      {
        modalOpen: false,
      },
      () => {
        if (this.props.onClose) {
          this.props.onClose();
        }
      }
    );
  };

  handleDateChange = newDate => {
    const { mode, onDateChange } = this.props;
    const { currentMode } = this.state;

    if (onDateChange) {
      onDateChange(newDate);
    }

    this.setState({
      date: newDate,
      currentMode:
        mode === DATETIME_PICKER && currentMode === DATE_PICKER
          ? TIME_PICKER
          : mode,
      // if mode is DATE_PICKER, close the modal immidiately
      modalOpen: mode !== DATE_PICKER,
    });
  };

  getDefaultFormat = () => {
    if (this.props.format) {
      return this.props.format;
    }
    switch (this.props.mode) {
      case DATETIME_PICKER:
        return 'DD MMMM YYYY HH:mm';
      case TIME_PICKER:
        return 'HH:mm';
      case DATE_PICKER:
      default:
        return 'DD MMMM YYYY';
    }
  };

  getFormattedDate = () => {
    return !this.props.value && this.props.hideDefaultValue
      ? ''
      : format(this.getDate(), this.getDefaultFormat(), {
          locale: getDateFNSLocale(this.props.locale),
        });
  };

  render() {
    const {
      /* eslint-disable no-unused-vars */
      // to prevent props spread into DRNInputField
      value,
      defaultValue,
      onDateChange,
      /* eslint-enable no-unused-vars */
      maximumDate,
      minimumDate,
      mode,
      locale,
      minuteInterval,
      timeZoneOffsetInMinutes,
      ...props
    } = this.props;
    const { currentMode } = this.state;

    const Picker = currentMode === DATE_PICKER ? Calendar : TimePicker;

    return (
      <React.Fragment>
        <TouchableInputFieldWrapper onPress={this.handleOpenDatePicker}>
          <DRNInputField
            {...props}
            editable={false}
            value={this.getFormattedDate()}
          />
        </TouchableInputFieldWrapper>
        <Modal
          isVisible={this.state.modalOpen}
          onBackdropPress={this.handleCloseDatePickerModal}
        >
          <Picker
            date={this.getDate()}
            onDateChange={this.handleDateChange}
            onClose={this.handleCloseDatePickerModal}
            maximumDate={maximumDate}
            minimumDate={minimumDate}
            showDate={mode === DATETIME_PICKER}
            locale={locale}
            // for web component
            // reset shown month (state) everytime modal open
            key={this.state.modalOpen.toString()}
          />
        </Modal>
      </React.Fragment>
    );
  }
}

export default InputDateField;
